// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"226":"password-reset","535":"login","567":"leaderboard","672":"mailwait","892":"PageNotFound"}[chunkId] + "." + {"226":"6c96c968","535":"d5c43af5","567":"c23c2728","672":"09a6d30f","892":"e02a2f3c"}[chunkId] + ".js";
};